import { createReducer } from 'typesafe-actions';
import { fetchAutoPayStatus } from '@store/actions/autoPayStatus.action';
import { AutoPay } from '@types';

export const autoPayStatus: AutoPay = {
    pendingPayments: []
};

export const autoPayStatusReducer = createReducer<any, any>(autoPayStatus)
    .handleAction(fetchAutoPayStatus.success, (state: any, action: { payload: any }) => ({
        ...state,
        ...action.payload
    }))
    .handleAction(fetchAutoPayStatus.failure, (state: any, action: { payload: any }) => ({
        ...state,
        ...action.payload
    }));
